import { Card, Flex, theme, Typography } from 'antd';
import React, { type ReactNode, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import LoginVerifyForm from './login-verify.form';
import { AuthContext } from '../../contexts/auth-context-provider';
// import bg from '../../images/background.jpg';

const LoginVerifyPage = (): ReactNode => {
  const { token } = theme.useToken();
  const { isAuthenticated, returnToApp } = useContext(AuthContext);
  const location = useLocation();

  const formData = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      email: params.get('email') || '',
      token: params.get('token') || '',
    };
  }, [location.search]);

  if (isAuthenticated) {
    return returnToApp;
  }

  return (
    <div>
      <Flex
        align="center"
        justify="center"
        style={{
          width: '100vw',
          height: '100vh',
          backdropFilter: 'blur(4px)',
          WebkitBackdropFilter: 'blur(4px)',
        }}
        vertical
      >
        <Typography.Title level={2} style={{ marginBottom: 50, fontWeight: 'bold' }}>
          <Typography.Text style={{ fontWeight: 400 }}>Welcome to</Typography.Text>
          <br />
          Hoffman House Catering
        </Typography.Title>
        <Card
          variant="outlined"
          styles={{
            body: { padding: token.paddingLG },
            header: { paddingInlineStart: token.paddingXS },
          }}
        >
          <LoginVerifyForm email={formData.email} token={formData.token} />
        </Card>
      </Flex>
    </div>
  );
};

export default LoginVerifyPage;
